<div class="flex-1 flex flex-col items-center justify-center p-6">
  <lucide-icon [img]="icons.Loader2" class="w-8 h-8 text-violet-400 animate-spin"></lucide-icon>
  <p class="text-gray-500 mt-3">{{ message() }}</p>
</div>
